// Referral capture (contract §4.22). Referral links look like
// https://<host>/?ref=<code>. The SPA owns the sharing surface: main.jsx
// captures the code into localStorage before anything renders (the visitor
// is usually anonymous and about to bounce through the Clerk sign-up flow),
// and <ReferralAttach /> posts it once a signed-in backend session exists.

export const REFERRAL_STORAGE_KEY = 'pp_referral_code'

// Grab ?ref=<code> from a query string into localStorage. Called from
// main.jsx before the first render so the code survives the sign-up
// redirects. Best-effort: storage failures (private mode, quota) are ignored.
export function captureReferralCode(search = window.location.search) {
  try {
    const code = new URLSearchParams(search).get('ref')
    if (code && code.trim()) {
      window.localStorage.setItem(REFERRAL_STORAGE_KEY, code.trim())
    }
  } catch {
    // ignore — referral capture must never break app boot
  }
}

export function getStoredReferralCode() {
  try {
    return window.localStorage.getItem(REFERRAL_STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearStoredReferralCode() {
  try {
    window.localStorage.removeItem(REFERRAL_STORAGE_KEY)
  } catch {
    // ignore
  }
}
